/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull murmur'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 61
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/implementation/murmur)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'default';

export const ApiKey: Record<Environment, string> = {
  default: '6cfe80b109d58db414efa2dbae828525'
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '61',
    branch: 'main',
    source: 'murmur',
    versionId: 'dc122608-6ec5-4462-a53d-9469cb573bb8'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  Account?: any;
  /**
   * A list of the survey IDs a user is the admin of, if any.
   */
  "Admin of surveys"?: any;
  "App Context"?: any;
  /**
   * The user's association type to the business (e.g. are they an employee or a consultant)
   */
  "Association type"?: string;
  /**
   * The date that the user account was created in the platform.
   */
  "Creation date"?: any;
  /**
   * January 2023 - Users will see a check box to tick off items that have been discussed in the 1:1. The hypothesis is the check box will increase usage of the agenda feature. The check box will be on the left with the drag handle on the left or right depending on the variation.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | DEFAULT, REORDER_IN_RIGHT, REORDER_IN_LEFT |
   */
  "Experiment variations: 1 on 1 agenda check box and reorder"?: "DEFAULT" | "REORDER_IN_RIGHT" | "REORDER_IN_LEFT";
  /**
   * This experiment was run in May 2023, to test whether the removal of an informative modal step when syncing a calendar event to a conversation with a direct report, will increase conversion rates. Users saw each variation on the 'Set Up 1 on 1 Calendar Integration Modal Viewed' page.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | DEFAULT, REMOVE_INFO_MODAL |
   */
  "Experiment variations: 1 on 1 calendar information modal"?: "DEFAULT" | "REMOVE_INFO_MODAL";
  /**
   * This experiment was run in June 2022, testing whether users are more likely to interact with agendas more by presenting users with different variations of the 1 on 1 check-in, aiming to improve week 1 user retention. 2 different variations will present the user with the sliders at the top of the checkin, one collapsible, the other not. This flag will only be sent to users who visit the 1 on 1 check-in space.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | DEFAULT, CHECK_IN_AT_TOP, COLLAPSIBLE_CHECK_IN_AT_TOP |
   */
  "Experiment variations: 1 on 1 reordered check-in"?: "DEFAULT" | "CHECK_IN_AT_TOP" | "COLLAPSIBLE_CHECK_IN_AT_TOP";
  /**
   * November 2023 - testing whether the first version of Home Connect released is more likely to drive greater homepage conversion of continuous performance actions. When this flag is false, users will see the old/existing version. When it's true, they will see the new version.
   */
  "Experiment variations: home connect v1"?: boolean;
  /**
   * June 2022 - testing whether rotating tiles on the home screen faster will make admins more likely to interact with them. When this flag is false, the survey closed/survey summary tiles will rotate every few weeks. When it’s true, the tiles will rotate every week.
   */
  "Experiment variations: home screen survey tile rotation"?: boolean;
  /**
   * August 2022 - testing whether a placing the task list below the home tiles will increase interactions and completions of tasks. When this value is true, the task list will be below the home tiles. When false, users will receive the default experience
   */
  "Experiment variations: home screen task list reposition"?: boolean;
  /**
   * July 2022 - testing whether a complete redesign of the survey welcome page will have any effect on whether users proceed through the survey. When this flag is false, users will see the old/existing version. When it's true, they will see the new version.
   */
  "Experiment variations: survey welcome page redesign"?: boolean;
  /**
   * A Flow-only user is a user in Slack or Teams who does not match to a Culture Amp user, thus has no userAggregateID. The ID for a Flow-only user should have 'flow' appended, e.g. flow-123456. This field will be empty on most users.
   */
  "Flow-only user"?: boolean;
  initial_dclid?: string;
  initial_fbclid?: string;
  initial_gbraid?: string;
  initial_gclid?: string;
  initial_ko_click_id?: string;
  initial_li_fat_id?: string;
  initial_msclkid?: string;
  /**
   * The referral source for the user to the product, the first time we ever see that user.
   */
  initial_referrer?: string;
  /**
   * The referral domain for the user to the product, the first time we ever see that user.
   */
  initial_referring_domain?: any;
  /**
   * The first referring domain for this user
   */
  "initial_referring_domain\t"?: string;
  initial_rtd_cid?: string;
  initial_ttclid?: string;
  initial_twclid?: string;
  /**
   * The UTM campaign source for the user to the product, the first time we ever see that user.
   */
  initial_utm_campaign?: any;
  /**
   * The UTM content value received, the first time we ever see that user. This is typically the name of the communication someone was sent.
   */
  initial_utm_content?: any;
  initial_utm_id?: string;
  /**
   * The UTM medium value received, the first time we ever see that user.
   */
  initial_utm_medium?: any;
  /**
   * The UTM source value received, the first time we ever see that user.
   */
  initial_utm_source?: any;
  /**
   * The UTM term value received, the first time we ever see that user.
   */
  initial_utm_term?: any;
  initial_wbraid?: string;
  /**
   * The first referral domain for this user to the product
   */
  intial_referring_domain?: string;
  /**
   * DEPRECATED - INCORRECT DATA; Is the user an account level admin?
   */
  "Is account admin"?: any;
  /**
   * Is the user an account level admin?
   */
  "Is account admin v2"?: string;
  /**
   * Is the user a manager? 'Unknown' indicates that we have no data and 'No' indicates we have data that tells us that they are not.
   */
  "Is manager"?: any;
  /**
   * Locale (language) chosen by the user. Users that have not chosen a locale use the account default. Originates from Influx.
   */
  Locale?: string;
  "Mongo user ID"?: any;
  /**
   * The referrer for this session
   */
  referrer?: string;
  /**
   * The referring domain for this session
   */
  referring_domain?: string;
  "Roles Assigned"?: any[];
  "Sign-in count"?: any;
  /**
   * The communication platform a user has set up for skills coach
   */
  "Skills coach communication platform"?: any;
  /**
   * (Superceded by the derived property of the same name). The age of the User Account in days from the date the account was created.
   */
  "User account age in days"?: any;
  /**
   * (Superceded by the derived property of the same name). The age of the User Account in months from the date the account was created.
   */
  "User account age in months"?: any;
  /**
   * (Superceded by the derived property of the same name). The age of the User Account in weeks from the date the account was created.
   */
  "User account age in weeks"?: any;
  /**
   * The User's age in years, calculated from their date of birth (if known).
   */
  "User age"?: any;
  /**
   * The users age range ie between 18-24 years old. Derived from Murmur date of birth (optional field). Added for grouping purposes. The prefixed letter is to assist ordering.
   */
  "User age range"?: any;
  /**
   * What user-level feature flags did the users have enabled?
   */
  "User feature flag enabled"?: any;
  /**
   * The UTM campaign source for the user for that particular session.
   */
  utm_campaign?: any;
  /**
   * The UTM content value for the session. This is typically the name of the communication someone was sent
   */
  utm_content?: any;
  /**
   * The UTM medium value for the user for that particular session.
   */
  utm_medium?: any;
  /**
   * Identifies where the user came from e.g. Slack, Email, Academy
   */
  utm_source?: any;
  /**
   * The UTM term value for the user, for that particular session.
   */
  utm_term?: any;
  /**
   * The height (in pixels) of the user's viewport. A viewport is essentially size of the content area in the browser.
   */
  "Viewport height"?: any;
  /**
   * The width (in pixels) of the user's viewport. A viewport is essentially size of the content area in the browser.
   */
  "Viewport width"?: any;
}

export interface AllCommentsReportViewedProperties {
  /**
   * The action framework ID associated with this report or action.
   */
  "Action framework ID"?: string;
  /**
   * If the 'translate enabled' toggle has been enabled
   */
  "Comments translate enabled"?: boolean;
  /**
   * Is there any custom content rendered in context of the event? For example a guidance popover, a temporary call to action banner etc
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Custom content enabled"?: string[];
  /**
   * The demographic group filters that are applied on report view
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Demographic filters"?: string[];
  /**
   * The manager 'anchor' level at which the report was generated
   */
  "Hierarchical anchor"?: any;
  /**
   * The hierarchical filters that are applied on report view
   */
  "Hierarchical filter"?: any;
  /**
   * The hierarchical filters that are applied on report view
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Hierarchical filters"?: string[];
  /**
   * The language selected using the 'any language' filter
   */
  "Language filter"?: string;
  /**
   * The Culture Amp platform includes modules such as Perform and Develop. As part of an interconnected platform, dimensions from modules (e.g Ratings from Perform) can be imported as demographic and used as a filter when viewing survey reports. This property is a list of the modules that the page is currently being filtered with.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Module filters used"?: string[];
  /**
   * The Question ID, selected using the 'any questions' filter
   */
  "Question filter"?: string;
  /**
   * The rating of comments, selected using the 'any rating' filter
   */
  "Rating filter"?: string;
  /**
   * Filter for comments with or without replies, or any comments.
   */
  "Replies filter"?: string;
  /**
   * The unique report ID associated with the action
   */
  "Report ID": string;
  /**
   * The name of the report viewed. On insight reports, this may include a demographic group name.
   */
  "Report name": string;
  /**
   * What was the high level report category? In survey reports, report types are "Advanced", "Participation", "Admin" etc. In continuous reports, report types are "Turnover Insights" etc.
   */
  "Report type"?: string;
  /**
   * The sentiment of comments, selected using the 'any sentiment'  filter
   */
  "Sentiment filter"?: string;
  /**
   * ID of the Engagement survey. This property is not part of the Survey group. Any event that has a Survey ID should also be logged with the Survey group.
   */
  "Survey ID"?: string;
  /**
   * The specific topic of comments, selected using the 'any topics' filter
   */
  "Topic filter"?: string;
}

export interface ChartExportMenuViewedProperties {
  /**
   * Which chart is the user trying to export or change? e.g. Likert scale, comments and trends, demographics chart, retention timeline, turnover by group
   */
  "Chart type": string;
  /**
   * In what context was this action performed? For events that can occur from more than one location (e.g. feedback given in Slack or the main app? manager review viewed from the admin view, the manager view, the subject view, the admin calibration view or the shared calibration view?)
   */
  Context?: string;
  /**
   * Is there any custom content rendered in context of the event? For example a guidance popover, a temporary call to action banner etc
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Custom content enabled"?: string[];
  /**
   * What method was used to complete the action? This property is applicable wherever there's multiple ways to perform an action (e.g. creating a survey from scratch or by duplicating another)
   */
  Method?: string;
  /**
   * The number of demographic values displayed on the demographic charts.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Number of demographic values displayed"?: number;
  /**
   * Many features are being rebuilt to use new micro-frontends. In this case, name the new version or repository so we can track the version users see during the rollout. e.g. conversations-ui.
   */
  "Rebuild version"?: string;
  /**
   * The display mode the user selected to view the data or page.
   */
  "View mode"?: string;
}

export interface ChartExportedProperties {
  /**
   * Which chart is the user trying to export or change? e.g. Likert scale, comments and trends, demographics chart, retention timeline, turnover by group
   */
  "Chart type": string;
  /**
   * In what context was this action performed? For events that can occur from more than one location (e.g. feedback given in Slack or the main app? manager review viewed from the admin view, the manager view, the subject view, the admin calibration view or the shared calibration view?)
   */
  Context?: string;
  /**
   * Performance: Did they export all personal data or data shared with manager?
   * Engagement: Did they copy the image or download it?
   * Develop: Did they export the participation report or insight report?
   */
  "Export type"?: string;
  /**
   * The number of demographic values displayed on the demographic charts.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Number of demographic values displayed"?: number;
  /**
   * Many features are being rebuilt to use new micro-frontends. In this case, name the new version or repository so we can track the version users see during the rollout. e.g. conversations-ui.
   */
  "Rebuild version"?: string;
  /**
   * The display mode the user selected to view the data or page.
   */
  "View mode"?: string;
}

export interface CommentsSummaryCopiedProperties {
  /**
   * The ID of the survey question flagged
   */
  "Question ID": string;
  /**
   * The sentiment of the summary comment copied, can be positive or negative or neutral.
   */
  "Summary sentiment"?: string;
  /**
   * Comment summaries can have topics such as "Leadership" and "Career". "Overall" or "None/Null" are also valid topics when overall topic summaries are displayed.
   */
  "Summary topic"?: string;
}

export interface CommentsSummaryFeedbackGivenProperties {
  /**
   * Users can provide either thumbs-up (positive) or thumbs-down (negative) feedback about a comment summarisation or representative comment selection in the comment summarisation drawer.
   */
  "Feedback sentiment": string;
  /**
   * What types of feedback does it include? e.g. Peer Feedback, Upward Feedback, Manager Evaluation.
   * For feedback given about Comments Summary in Engage reports, feedback can have two types: about the comment summarisation or about the representative comments displayed.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Feedback type"?: string[];
  /**
   * The ID of the survey question flagged
   */
  "Question ID": string;
}

export interface CommentsSummaryViewedProperties {
  /**
   * In what context was this action performed? For events that can occur from more than one location (e.g. feedback given in Slack or the main app? manager review viewed from the admin view, the manager view, the subject view, the admin calibration view or the shared calibration view?)
   */
  Context?: string;
  /**
   * In the Comments Summary drawer user can expand to see representative comments.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Number of representative comments viewed": number;
  /**
   * If topic summaries are available, they can be viewed in the comments summary drawer. Toggling between the topic tabs enabled the users to view the available topic summaries (up to 3)
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Number of topic summaries viewed"?: number;
  /**
   * The comments summary drawer will populate with topic the related comments data allows.
   * By default the top 3 will be displayed, and the user can expand the section to see 10 topics
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Number of topics displayed"?: number;
  /**
   * The ID of the survey question flagged
   */
  "Question ID": string;
}

export interface CustomHeatmapReportViewedProperties {
  /**
   * We display a confidentiality warning in circumstances when the number of survey responses to display is below the reporting group minimum or indirect identification protections have been enabled. This may be because of filters applied to reports. If this property is null, it means that no warning is displayed.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Direct, Indirect |
   */
  "Confidentiality warning displayed"?: "Direct" | "Indirect";
  /**
   * What value is the heatmap compared on? Delta or % favourable score
   */
  "Heatmap value comparison type"?: string;
  /**
   * The Culture Amp platform includes modules such as Perform and Develop. As part of an interconnected platform, dimensions from modules (e.g Ratings from Perform) can be imported as demographic and used as a filter when viewing survey reports. This property is a list of the modules that the page is currently being filtered with.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Module filters used": string[];
  /**
   * The number of columns displayed in the Heatmap report. This is controlled applying filters or for the Custom Heatmap or by creating Demographic Groups.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Number of columns"?: number;
  /**
   * The unique report ID associated with the action
   */
  "Report ID": string;
  /**
   * What was the high level report category? In survey reports, report types are "Advanced", "Participation", "Admin" etc. In continuous reports, report types are "Turnover Insights" etc.
   */
  "Report type": string;
}

export interface DemographicGroupForHeatmapAddedProperties {
  /**
   * How many different filters are applied to the report? This should be the number of elements in the array "Filters applied".
   *
   * In the context of Custom Heatmap: A demographic group used to for the Custom Heatmap report is made by adding one or multiple search criteria to filter employees. This property is the number of search criteria (filters) used to create single demographic group.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Number of filters applied": number;
}

export interface FactorInsightReportViewedProperties {
  /**
   * The action framework ID associated with this report or action.
   */
  "Action framework ID"?: string;
  /**
   * Name of the comparison that's selected on view
   */
  "Comparison name"?: string;
  /**
   * Type of the comparison that's selected on view
   */
  "Comparison type"?: string;
  /**
   * We display a confidentiality warning in circumstances when the number of survey responses to display is below the reporting group minimum or indirect identification protections have been enabled. This may be because of filters applied to reports. If this property is null, it means that no warning is displayed.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Direct, Indirect |
   */
  "Confidentiality warning displayed"?: "Direct" | "Indirect";
  /**
   * Is there any custom content rendered in context of the event? For example a guidance popover, a temporary call to action banner etc
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Custom content enabled"?: string[];
  /**
   * The demographic group filters that are applied on report view
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Demographic filters"?: string[];
  /**
   * The name of the factor created, viewed, edited or deleted in the event. (In the "Factor Edited" event, this should be the old name)
   */
  "Factor name"?: string;
  /**
   * The number of questions associated with a factor selected
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Factor questions"?: number;
  /**
   * The manager 'anchor' level at which the report was generated
   */
  "Hierarchical anchor"?: any;
  /**
   * The hierarchical filters that are applied on report view
   */
  "Hierarchical filter"?: any;
  /**
   * The hierarchical filters that are applied on report view
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Hierarchical filters"?: string[];
  /**
   * The Culture Amp platform includes modules such as Perform and Develop. As part of an interconnected platform, dimensions from modules (e.g Ratings from Perform) can be imported as demographic and used as a filter when viewing survey reports. This property is a list of the modules that the page is currently being filtered with.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Module filters used"?: string[];
  /**
   * The unique report ID associated with the action
   */
  "Report ID": string;
  /**
   * The name of the report viewed. On insight reports, this may include a demographic group name.
   */
  "Report name": string;
  /**
   * What was the high level report category? In survey reports, report types are "Advanced", "Participation", "Admin" etc. In continuous reports, report types are "Turnover Insights" etc.
   */
  "Report type"?: string;
  /**
   * ID of the Engagement survey. This property is not part of the Survey group. Any event that has a Survey ID should also be logged with the Survey group.
   */
  "Survey ID"?: string;
}

export interface FocusAreaFlaggedProperties {
  /**
   * Is the flagged focus area one of the group level focus areas recommended by Culture Amp?
   */
  "Is this a recommended focus?": boolean;
  /**
   * The ID of the survey question flagged
   */
  "Question ID": string;
}

export interface FreeTextQuestionsReportViewedProperties {
  /**
   * The action framework ID associated with this report or action.
   */
  "Action framework ID"?: string;
  /**
   * Name of the comparison that's selected on view
   */
  "Comparison name"?: string;
  /**
   * Type of the comparison that's selected on view
   */
  "Comparison type"?: string;
  /**
   * We display a confidentiality warning in circumstances when the number of survey responses to display is below the reporting group minimum or indirect identification protections have been enabled. This may be because of filters applied to reports. If this property is null, it means that no warning is displayed.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Direct, Indirect |
   */
  "Confidentiality warning displayed"?: "Direct" | "Indirect";
  /**
   * Is there any custom content rendered in context of the event? For example a guidance popover, a temporary call to action banner etc
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Custom content enabled"?: string[];
  /**
   * The demographic group filters that are applied on report view
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Demographic filters"?: string[];
  /**
   * The manager 'anchor' level at which the report was generated
   */
  "Hierarchical anchor"?: any;
  /**
   * The hierarchical filters that are applied on report view
   */
  "Hierarchical filter"?: any;
  /**
   * Any hierarchical filters that are applied on report view
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Hierarchical filters"?: string[];
  /**
   * The Culture Amp platform includes modules such as Perform and Develop. As part of an interconnected platform, dimensions from modules (e.g Ratings from Perform) can be imported as demographic and used as a filter when viewing survey reports. This property is a list of the modules that the page is currently being filtered with.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Module filters used"?: string[];
  /**
   * The unique report ID associated with the action
   */
  "Report ID"?: string;
  /**
   * The name of the report viewed. On insight reports, this may include a demographic group name.
   */
  "Report name": string;
  /**
   * What was the high level report category? In survey reports, report types are "Advanced", "Participation", "Admin" etc. In continuous reports, report types are "Turnover Insights" etc.
   */
  "Report type"?: string;
}

export interface HeatmapReportViewedProperties {
  /**
   * The action framework ID associated with this report or action.
   */
  "Action framework ID"?: string;
  /**
   * Name of the comparison that's selected on view
   */
  "Comparison name"?: string;
  /**
   * Type of the comparison that's selected on view
   */
  "Comparison type"?: string;
  /**
   * We display a confidentiality warning in circumstances when the number of survey responses to display is below the reporting group minimum or indirect identification protections have been enabled. This may be because of filters applied to reports. If this property is null, it means that no warning is displayed.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Direct, Indirect |
   */
  "Confidentiality warning displayed"?: "Direct" | "Indirect";
  /**
   * Is there any custom content rendered in context of the event? For example a guidance popover, a temporary call to action banner etc
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Custom content enabled"?: string[];
  /**
   * The demographic group filters that are applied on report view
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Demographic filters"?: string[];
  /**
   * The heatmap demographic selected
   */
  "Heatmap demographic"?: string;
  /**
   * What value is the heatmap compared on? Delta or % favourable score
   */
  "Heatmap value comparison type"?: string;
  /**
   * The manager 'anchor' level at which the report was generated
   */
  "Hierarchical anchor"?: any;
  /**
   * The hierarchical filters that are applied on report view
   */
  "Hierarchical filter"?: any;
  /**
   * The hierarchical filters that are applied on report view
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Hierarchical filters"?: string[];
  /**
   * The Culture Amp platform includes modules such as Perform and Develop. As part of an interconnected platform, dimensions from modules (e.g Ratings from Perform) can be imported as demographic and used as a filter when viewing survey reports. This property is a list of the modules that the page is currently being filtered with.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Module filters used"?: string[];
  /**
   * The number of columns displayed in the Heatmap report. This is controlled applying filters or for the Custom Heatmap or by creating Demographic Groups.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Number of columns"?: number;
  /**
   * The unique report ID associated with the action
   */
  "Report ID": string;
  /**
   * The name of the report viewed. On insight reports, this may include a demographic group name.
   */
  "Report name": string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Custom, Demographics |
   */
  "Report subtype"?: "Custom" | "Demographics";
  /**
   * What was the high level report category? In survey reports, report types are "Advanced", "Participation", "Admin" etc. In continuous reports, report types are "Turnover Insights" etc.
   */
  "Report type"?: string;
  /**
   * Where the user came from prior to triggering this event. E.g. when viewing a report, did the user come from a Slack or Email notification?
   */
  Source?: string;
  /**
   * ID of the Engagement survey. This property is not part of the Survey group. Any event that has a Survey ID should also be logged with the Survey group.
   */
  "Survey ID"?: string;
  /**
   * Whether favourable scores or deltas are displayed
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Delta, Favourable Score |
   */
  "Values displayed"?: "Delta" | "Favourable Score";
}

export interface InsightReportViewedProperties {
  /**
   * The action framework ID associated with this report or action.
   */
  "Action framework ID"?: string;
  /**
   * Name of the comparison that's selected on view
   */
  "Comparison name"?: string;
  /**
   * Type of the comparison that's selected on view
   */
  "Comparison type"?: string;
  /**
   * We display a confidentiality warning in circumstances when the number of survey responses to display is below the reporting group minimum or indirect identification protections have been enabled. This may be because of filters applied to reports. If this property is null, it means that no warning is displayed.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Direct, Indirect |
   */
  "Confidentiality warning displayed"?: "Direct" | "Indirect";
  /**
   * The demographic group filters that are applied on report view
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Demographic filters"?: string[];
  /**
   * The manager 'anchor' level at which the report was generated
   */
  "Hierarchical anchor"?: any;
  /**
   * The hierarchical filters that are applied on report view
   */
  "Hierarchical filter"?: any;
  /**
   * Will be `true` only if the user who triggers the event has been assigned the Engage HR Business Partner role.
   */
  "Is Engage HR business partner": boolean;
  /**
   * Is the user viewing a preview of the survey or report? A preview will have a banner warning the user that it's a preview.
   */
  "Is preview?"?: boolean;
  /**
   * The Culture Amp platform includes modules such as Perform and Develop. As part of an interconnected platform, dimensions from modules (e.g Ratings from Perform) can be imported as demographic and used as a filter when viewing survey reports. This property is a list of the modules that the page is currently being filtered with.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Module filters used"?: string[];
  /**
   * The unique report ID associated with the action
   */
  "Report ID": string;
  /**
   * The name of the report viewed. On insight reports, this may include a demographic group name.
   */
  "Report name": string;
  /**
   * What was the high level report category? In survey reports, report types are "Advanced", "Participation", "Admin" etc. In continuous reports, report types are "Turnover Insights" etc.
   */
  "Report type"?: string;
  /**
   * ID of the Engagement survey. This property is not part of the Survey group. Any event that has a Survey ID should also be logged with the Survey group.
   */
  "Survey ID"?: string;
}

export interface MultipleChoiceQuestionsReportViewedProperties {
  /**
   * The action framework ID associated with this report or action.
   */
  "Action framework ID"?: string;
  /**
   * Name of the comparison that's selected on view
   */
  "Comparison name"?: string;
  /**
   * Type of the comparison that's selected on view
   */
  "Comparison type"?: string;
  /**
   * We display a confidentiality warning in circumstances when the number of survey responses to display is below the reporting group minimum or indirect identification protections have been enabled. This may be because of filters applied to reports. If this property is null, it means that no warning is displayed.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Direct, Indirect |
   */
  "Confidentiality warning displayed"?: "Direct" | "Indirect";
  /**
   * Is there any custom content rendered in context of the event? For example a guidance popover, a temporary call to action banner etc
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Custom content enabled"?: string[];
  /**
   * The demographic group filters that are applied on report view
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Demographic filters"?: string[];
  /**
   * The manager 'anchor' level at which the report was generated
   */
  "Hierarchical anchor"?: any;
  /**
   * The hierarchical filters that are applied on report view
   */
  "Hierarchical filter"?: any;
  /**
   * The hierarchical filters that are applied on report view
   */
  "Hierarchical filters"?: string;
  /**
   * The Culture Amp platform includes modules such as Perform and Develop. As part of an interconnected platform, dimensions from modules (e.g Ratings from Perform) can be imported as demographic and used as a filter when viewing survey reports. This property is a list of the modules that the page is currently being filtered with.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Module filters used"?: string[];
  /**
   * The unique report ID associated with the action
   */
  "Report ID"?: string;
  /**
   * The name of the report viewed. On insight reports, this may include a demographic group name.
   */
  "Report name": string;
  /**
   * What was the high level report category? In survey reports, report types are "Advanced", "Participation", "Admin" etc. In continuous reports, report types are "Turnover Insights" etc.
   */
  "Report type"?: string;
}

export interface OutboundDestinationVisitedProperties {
  /**
   * In what context was this action performed? For events that can occur from more than one location (e.g. feedback given in Slack or the main app? manager review viewed from the admin view, the manager view, the subject view, the admin calibration view or the shared calibration view?)
   */
  Context?: string;
  /**
   * Is there any custom content rendered in context of the event? For example a guidance popover, a temporary call to action banner etc
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Custom content enabled"?: string[];
  /**
   * The domain of the destination they visited e.g. skilljar.com
   */
  "Destination domain": string;
  /**
   * The name of the element clicked. If it's a hyper link this will be the link text, for buttons, the button name. Send this in English, rather than the localised version.
   */
  "Element clicked name": string;
  /**
   * Capture top level of where the page sits in the site hierarchy (i.e. according to the top menu bar). This was historically used to track usage of navigation in the UI.
   */
  "Site hierarchy - L1"?: string;
}

export interface ParticipationReportViewedProperties {
  /**
   * The action framework ID associated with this report or action.
   */
  "Action framework ID"?: string;
  /**
   * Name of the comparison that's selected on view
   */
  "Comparison name"?: string;
  /**
   * Type of the comparison that's selected on view
   */
  "Comparison type"?: string;
  /**
   * We display a confidentiality warning in circumstances when the number of survey responses to display is below the reporting group minimum or indirect identification protections have been enabled. This may be because of filters applied to reports. If this property is null, it means that no warning is displayed.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Direct, Indirect |
   */
  "Confidentiality warning displayed"?: "Direct" | "Indirect";
  /**
   * Is there any custom content rendered in context of the event? For example a guidance popover, a temporary call to action banner etc
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Custom content enabled"?: string[];
  /**
   * The demographic group filters that are applied on report view
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Demographic filters"?: string[];
  /**
   * The manager 'anchor' level at which the report was generated
   */
  "Hierarchical anchor"?: any;
  /**
   * The hierarchical filters that are applied on report view
   */
  "Hierarchical filter"?: any;
  /**
   * The hierarchical filters that are applied on report view
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Hierarchical filters"?: string[];
  /**
   * The Culture Amp platform includes modules such as Perform and Develop. As part of an interconnected platform, dimensions from modules (e.g Ratings from Perform) can be imported as demographic and used as a filter when viewing survey reports. This property is a list of the modules that the page is currently being filtered with.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Module filters used"?: string[];
  /**
   * The unique report ID associated with the action
   */
  "Report ID"?: string;
  /**
   * The name of the report viewed. On insight reports, this may include a demographic group name.
   */
  "Report name": string;
  /**
   * What was the high level report category? In survey reports, report types are "Advanced", "Participation", "Admin" etc. In continuous reports, report types are "Turnover Insights" etc.
   */
  "Report type"?: string;
  source?: any;
  /**
   * Whether the user came from Slack or email to view the report
   */
  Source?: any;
  /**
   * ID of the Engagement survey. This property is not part of the Survey group. Any event that has a Survey ID should also be logged with the Survey group.
   */
  "Survey ID"?: string;
}

export interface PostSurveyFeedbackSubmittedProperties {
  /**
   * The rating associated with a survey when completed
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  Rating?: number;
}

export interface QuestionsReportViewedProperties {
  /**
   * The action framework ID associated with this report or action.
   */
  "Action framework ID"?: string;
  /**
   * Name of the comparison that's selected on view
   */
  "Comparison name"?: string;
  /**
   * Type of the comparison that's selected on view
   */
  "Comparison type"?: string;
  /**
   * We display a confidentiality warning in circumstances when the number of survey responses to display is below the reporting group minimum or indirect identification protections have been enabled. This may be because of filters applied to reports. If this property is null, it means that no warning is displayed.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Direct, Indirect |
   */
  "Confidentiality warning displayed"?: "Direct" | "Indirect";
  /**
   * Is there any custom content rendered in context of the event? For example a guidance popover, a temporary call to action banner etc
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Custom content enabled"?: string[];
  /**
   * The demographic group filters that are applied on report view
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Demographic filters"?: string[];
  /**
   * The manager 'anchor' level at which the report was generated
   */
  "Hierarchical anchor"?: any;
  /**
   * The hierarchical filters that are applied on report view
   */
  "Hierarchical filter"?: any;
  /**
   * The hierarchical filters that are applied on report view
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Hierarchical filters"?: string[];
  /**
   * The Culture Amp platform includes modules such as Perform and Develop. As part of an interconnected platform, dimensions from modules (e.g Ratings from Perform) can be imported as demographic and used as a filter when viewing survey reports. This property is a list of the modules that the page is currently being filtered with.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Module filters used"?: string[];
  /**
   * Flag to see whether a particular question has been expanded when the report is rendered
   */
  "Question expanded"?: boolean;
  /**
   * An array of filters applied to the questions rendered (if applicable)
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Question filters"?: string[];
  /**
   * The unique report ID associated with the action
   */
  "Report ID"?: string;
  /**
   * The name of the report viewed. On insight reports, this may include a demographic group name.
   */
  "Report name": string;
  /**
   * What was the high level report category? In survey reports, report types are "Advanced", "Participation", "Admin" etc. In continuous reports, report types are "Turnover Insights" etc.
   */
  "Report type"?: string;
}

export interface ReportExportedProperties {
  /**
   * In what context was this action performed? For events that can occur from more than one location (e.g. feedback given in Slack or the main app? manager review viewed from the admin view, the manager view, the subject view, the admin calibration view or the shared calibration view?)
   */
  Context?: string;
  /**
   * The format of the report export. e.g. PDF, XLS, Image, CSV, PPT, Raw, Print
   */
  Format?: string;
  /**
   * The unique report ID associated with the action
   */
  "Report ID"?: string;
  /**
   * ID of the Engagement survey. This property is not part of the Survey group. Any event that has a Survey ID should also be logged with the Survey group.
   */
  "Survey ID"?: string;
  /**
   * The type of object submitted
   */
  Type?: string;
}

export interface ReportViewerImportErrorFileDownloadedProperties {
  /**
   * For import/validation jobs that are tracked via job numbers.
   */
  "Job ID": string;
}

export interface ReportViewersUpdatedProperties {
  /**
   * Will be `true` only if the user who triggers the event has been assigned the Engage HR Business Partner role.
   */
  "Is Engage HR business partner": boolean;
  /**
   * What is the net difference in number of report viewers, after the admin has saved their changes?
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Net report viewers added or removed": number;
}

export interface SingleQuestionReportViewedProperties {
  /**
   * The action framework ID associated with this report or action.
   */
  "Action framework ID"?: string;
  /**
   * Name of the comparison that's selected on view
   */
  "Comparison name"?: string;
  /**
   * Type of the comparison that's selected on view
   */
  "Comparison type"?: string;
  /**
   * We display a confidentiality warning in circumstances when the number of survey responses to display is below the reporting group minimum or indirect identification protections have been enabled. This may be because of filters applied to reports. If this property is null, it means that no warning is displayed.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Direct, Indirect |
   */
  "Confidentiality warning displayed"?: "Direct" | "Indirect";
  /**
   * Is there any custom content rendered in context of the event? For example a guidance popover, a temporary call to action banner etc
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Custom content enabled"?: string[];
  /**
   * The demographic group filters that are applied on report view
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Demographic filters"?: string[];
  /**
   * The manager 'anchor' level at which the report was generated
   */
  "Hierarchical anchor"?: any;
  /**
   * The hierarchical filters that are applied on report view
   */
  "Hierarchical filter"?: any;
  /**
   * The hierarchical filters that are applied on report view
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Hierarchical filters"?: string[];
  /**
   * The Culture Amp platform includes modules such as Perform and Develop. As part of an interconnected platform, dimensions from modules (e.g Ratings from Perform) can be imported as demographic and used as a filter when viewing survey reports. This property is a list of the modules that the page is currently being filtered with.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Module filters used"?: string[];
  /**
   * The Question ID associated with this report
   */
  "Question Id"?: any;
  /**
   * The ID of the survey question flagged
   */
  "Question ID"?: string;
  /**
   * The question text
   */
  "Question name"?: string;
  /**
   * The unique report ID associated with the action
   */
  "Report ID": string;
  /**
   * The name of the report viewed. On insight reports, this may include a demographic group name.
   */
  "Report name": string;
  /**
   * What was the high level report category? In survey reports, report types are "Advanced", "Participation", "Admin" etc. In continuous reports, report types are "Turnover Insights" etc.
   */
  "Report type"?: string;
}

export interface SubReportViewersDeletedProperties {
  /**
   * Did the job (download/upload/import) fail to complete, possibly due to a malformed CSV?
   */
  "Job failed": boolean;
  /**
   * The number of report viewers deleted by the bulk delete option in survey sharing configuration.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "Viewers deleted": number;
}

export interface SummaryInsightReportViewedProperties {
  /**
   * The action framework ID associated with this report or action.
   */
  "Action framework ID"?: string;
  /**
   * Name of the comparison that's selected on view
   */
  "Comparison name"?: string;
  /**
   * Type of the comparison that's selected on view
   */
  "Comparison type"?: string;
  /**
   * We display a confidentiality warning in circumstances when the number of survey responses to display is below the reporting group minimum or indirect identification protections have been enabled. This may be because of filters applied to reports. If this property is null, it means that no warning is displayed.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Direct, Indirect |
   */
  "Confidentiality warning displayed"?: "Direct" | "Indirect";
  /**
   * Is there any custom content rendered in context of the event? For example a guidance popover, a temporary call to action banner etc
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Custom content enabled"?: string[];
  /**
   * The demographic group filters that are applied on report view
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Demographic filters"?: string[];
  /**
   * The manager 'anchor' level at which the report was generated
   */
  "Hierarchical anchor"?: any;
  /**
   * The hierarchical filters that are applied on report view
   */
  "Hierarchical filter"?: any;
  /**
   * The Culture Amp platform includes modules such as Perform and Develop. As part of an interconnected platform, dimensions from modules (e.g Ratings from Perform) can be imported as demographic and used as a filter when viewing survey reports. This property is a list of the modules that the page is currently being filtered with.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Module filters used"?: string[];
  /**
   * The unique report ID associated with the action
   */
  "Report ID"?: string;
  /**
   * The name of the report viewed. On insight reports, this may include a demographic group name.
   */
  "Report name": string;
  /**
   * What was the high level report category? In survey reports, report types are "Advanced", "Participation", "Admin" etc. In continuous reports, report types are "Turnover Insights" etc.
   */
  "Report type"?: string;
}

export interface SurveyConfigurationPostLaunchTrendSavedProperties {
  /**
   * The date in YYYY-MM format of the oldest survey that is selected to be included for Trend analysis
   */
  "Date of oldest survey included": string;
}

export interface SurveyConfigureKioskModeLinkClickedProperties {
  /**
   * The name of the element clicked. If it's a hyper link this will be the link text, for buttons, the button name. Send this in English, rather than the localised version.
   */
  "Element clicked name": string;
}

export interface SurveyConfigureKioskModeUpdatedProperties {
  /**
   * The locale code of the message.
   */
  Locale?: string;
  /**
   * Was the message updated as part of updating kiosk mode?
   */
  "Message updated": boolean;
}

export interface SurveyConfigureLikertScaleUpdatedProperties {
  /**
   * The colour of the likert scale chosen for the survey.
   */
  "Likert colour": string;
}

export interface SurveyConfigureModuleFilterUpdatedProperties {
  /**
   * The Culture Amp platform includes modules such as Perform and Develop. As part of an interconnected platform, dimensions from modules (e.g Ratings from Perform) can be imported as demographic into Engage Surveys. This property is for the dimension of the imported demographic filter.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | rating |
   */
  "Filter dimension": "rating";
  /**
   * The Culture Amp platform includes modules such as Perform and Develop. As part of an interconnected platform, dimensions from modules (e.g Ratings from Perform) can be imported as demographic into Engage Surveys. This property is for the module of the imported demographic filter.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | perform |
   */
  "Filter module": "perform";
  /**
   * Was the element added, updated, deleted, marked complete, marked incomplete, expanded, collapsed, etc.?
   */
  "Update action": string;
}

export interface SurveyConfigurePostLaunchTrendViewedProperties {
  /**
   * Is there any custom content rendered in context of the event? For example a guidance popover, a temporary call to action banner etc
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Custom content enabled"?: string[];
  /**
   * How did the user navigate to completing this event (e.g. from the task widget, the platform menus or a platform communication?)
   */
  "Navigation source"?: string;
  /**
   * ID of the Engagement survey. This property is not part of the Survey group. Any event that has a Survey ID should also be logged with the Survey group.
   */
  "Survey ID"?: string;
}

export interface SurveyConfigurePreviewLinkCopiedProperties {
  /**
   * In what context was this action performed? For events that can occur from more than one location (e.g. feedback given in Slack or the main app? manager review viewed from the admin view, the manager view, the subject view, the admin calibration view or the shared calibration view?)
   */
  Context?: string;
}

export interface SurveyConfigureQuestionsExportedProperties {
  /**
   * In what context was this action performed? For events that can occur from more than one location (e.g. feedback given in Slack or the main app? manager review viewed from the admin view, the manager view, the subject view, the admin calibration view or the shared calibration view?)
   */
  Context?: string;
  /**
   * The format of the report export. e.g. PDF, XLS, Image, CSV, PPT, Raw, Print
   */
  Format?: string;
}

export interface SurveyConfigureQuestionsViewedProperties {
  /**
   * Is there any custom content rendered in context of the event? For example a guidance popover, a temporary call to action banner etc
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "Custom content enabled"?: string[];
  /**
   * Capture top level of where the page sits in the site hierarchy (i.e. according to the top menu bar). This was historically used to track usage of navigation in the UI.
   */
  "Site hierarchy - L1"?: string;
}

export interface SurveySummaryCreationBannerViewedProperties {
  /**
   * In what context was this action performed? For events that can occur from more than one location (e.g. feedback given in Slack or the main app? manager review viewed from the admin view, the manager view, the subject view, the admin calibration view or the shared calibration view?)
   */
  Context?: string;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(
    public event_properties?: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AllCommentsReportViewed implements BaseEvent {
  event_type = 'All Comments Report Viewed';

  constructor(
    public event_properties: AllCommentsReportViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChartExportMenuViewed implements BaseEvent {
  event_type = 'Chart Export Menu Viewed';

  constructor(
    public event_properties: ChartExportMenuViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChartExported implements BaseEvent {
  event_type = 'Chart Exported';

  constructor(
    public event_properties: ChartExportedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CommentsSummaryCopied implements BaseEvent {
  event_type = 'Comments Summary Copied';

  constructor(
    public event_properties: CommentsSummaryCopiedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CommentsSummaryFeedbackGiven implements BaseEvent {
  event_type = 'Comments Summary Feedback Given';

  constructor(
    public event_properties: CommentsSummaryFeedbackGivenProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CommentsSummaryViewed implements BaseEvent {
  event_type = 'Comments Summary Viewed';

  constructor(
    public event_properties: CommentsSummaryViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CustomHeatmapReportViewed implements BaseEvent {
  event_type = 'Custom Heatmap Report Viewed';

  constructor(
    public event_properties: CustomHeatmapReportViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DataSafetyPolicyViewed implements BaseEvent {
  event_type = 'Data Safety Policy Viewed';
}

export class DemographicGroupForHeatmapAdded implements BaseEvent {
  event_type = 'Demographic Group for Heatmap Added';

  constructor(
    public event_properties: DemographicGroupForHeatmapAddedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EmergingThemeViewed implements BaseEvent {
  event_type = 'Emerging Theme Viewed';
}

export class FactorInsightReportViewed implements BaseEvent {
  event_type = 'Factor Insight Report Viewed';

  constructor(
    public event_properties: FactorInsightReportViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FilteredReportsPageViewed implements BaseEvent {
  event_type = 'Filtered Reports Page Viewed';
}

export class FocusAreaFlagged implements BaseEvent {
  event_type = 'Focus Area Flagged';

  constructor(
    public event_properties: FocusAreaFlaggedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FreeTextQuestionsReportViewed implements BaseEvent {
  event_type = 'Free Text Questions Report Viewed';

  constructor(
    public event_properties: FreeTextQuestionsReportViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class GroupLevelDriverModalViewed implements BaseEvent {
  event_type = 'Group Level Driver Modal Viewed';
}

export class HeatmapReportViewed implements BaseEvent {
  event_type = 'Heatmap Report Viewed';

  constructor(
    public event_properties: HeatmapReportViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InsightReportViewed implements BaseEvent {
  event_type = 'Insight Report Viewed';

  constructor(
    public event_properties: InsightReportViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MultipleChoiceQuestionsReportViewed implements BaseEvent {
  event_type = 'Multiple Choice Questions Report Viewed';

  constructor(
    public event_properties: MultipleChoiceQuestionsReportViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class OutboundDestinationVisited implements BaseEvent {
  event_type = 'Outbound Destination Visited';

  constructor(
    public event_properties: OutboundDestinationVisitedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ParticipationReportViewed implements BaseEvent {
  event_type = 'Participation Report Viewed';

  constructor(
    public event_properties: ParticipationReportViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PostSurveyFeedbackSubmitted implements BaseEvent {
  event_type = 'Post-Survey Feedback Submitted';

  constructor(
    public event_properties?: PostSurveyFeedbackSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class QuestionsReportViewed implements BaseEvent {
  event_type = 'Questions Report Viewed';

  constructor(
    public event_properties: QuestionsReportViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RedactionRequestSubmitted implements BaseEvent {
  event_type = 'Redaction Request Submitted';
}

export class ReportExported implements BaseEvent {
  event_type = 'Report Exported';

  constructor(
    public event_properties?: ReportExportedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ReportViewerBulkDeletionStarted implements BaseEvent {
  event_type = 'Report Viewer Bulk Deletion Started';
}

export class ReportViewerExportDownloadStarted implements BaseEvent {
  event_type = 'Report Viewer Export Download Started';
}

export class ReportViewerImportErrorFileDownloaded implements BaseEvent {
  event_type = 'Report Viewer Import Error File Downloaded';

  constructor(
    public event_properties: ReportViewerImportErrorFileDownloadedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ReportViewersUpdated implements BaseEvent {
  event_type = 'Report Viewers Updated';

  constructor(
    public event_properties: ReportViewersUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SingleQuestionReportViewed implements BaseEvent {
  event_type = 'Single Question Report Viewed';

  constructor(
    public event_properties: SingleQuestionReportViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SpecificSurveyRulesViewed implements BaseEvent {
  event_type = 'Specific Survey Rules Viewed';
}

export class SubReportViewersDeleted implements BaseEvent {
  event_type = 'Sub Report Viewers Deleted';

  constructor(
    public event_properties: SubReportViewersDeletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SummaryInsightReportViewed implements BaseEvent {
  event_type = 'Summary Insight Report Viewed';

  constructor(
    public event_properties: SummaryInsightReportViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SurveyConfigurationPostLaunchTrendSaved implements BaseEvent {
  event_type = 'Survey Configuration - Post Launch Trend Saved';

  constructor(
    public event_properties: SurveyConfigurationPostLaunchTrendSavedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SurveyConfigureKioskModeLinkClicked implements BaseEvent {
  event_type = 'Survey Configure - Kiosk Mode Link Clicked';

  constructor(
    public event_properties: SurveyConfigureKioskModeLinkClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SurveyConfigureKioskModeUpdated implements BaseEvent {
  event_type = 'Survey Configure - Kiosk Mode Updated';

  constructor(
    public event_properties: SurveyConfigureKioskModeUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SurveyConfigureLikertScaleUpdated implements BaseEvent {
  event_type = 'Survey Configure - Likert Scale Updated';

  constructor(
    public event_properties: SurveyConfigureLikertScaleUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SurveyConfigureModuleFilterUpdated implements BaseEvent {
  event_type = 'Survey Configure - Module Filter Updated';

  constructor(
    public event_properties: SurveyConfigureModuleFilterUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SurveyConfigurePostLaunchTrendViewed implements BaseEvent {
  event_type = 'Survey Configure - Post Launch Trend Viewed';

  constructor(
    public event_properties?: SurveyConfigurePostLaunchTrendViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SurveyConfigurePreviewLinkCopied implements BaseEvent {
  event_type = 'Survey Configure - Preview Link Copied';

  constructor(
    public event_properties?: SurveyConfigurePreviewLinkCopiedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SurveyConfigureQuestionsExported implements BaseEvent {
  event_type = 'Survey Configure - Questions Exported';

  constructor(
    public event_properties?: SurveyConfigureQuestionsExportedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SurveyConfigureQuestionsViewed implements BaseEvent {
  event_type = 'Survey Configure - Questions Viewed';

  constructor(
    public event_properties?: SurveyConfigureQuestionsViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SurveyDesignViewed implements BaseEvent {
  event_type = 'Survey Design Viewed';
}

export class SurveyStarted implements BaseEvent {
  event_type = 'Survey Started';
}

export class SurveySummaryCreationBannerViewed implements BaseEvent {
  event_type = 'Survey Summary Creation Banner Viewed';

  constructor(
    public event_properties?: SurveySummaryCreationBannerViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SurveyWelcomePageViewed implements BaseEvent {
  event_type = 'Survey Welcome Page Viewed';
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * All Comments Report Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/All%20Comments%20Report%20Viewed)
   *
   * A user views the 'All comments' tab of the Comments report, in Engagement.
   * A filter/s is applied to the 'All comments' tab.
   *
   * Triggers:
   * 1. user lands on All Comments Reports Viewed page 
   *   _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/qf85YdJGq9HCE67DVuPd79ySQXcy9D_-JT2E_z7vbFQvjIxpc0K65lfIKq1ZWAzr5v4rMnobFIItvhpgvKAYOahExkkdSlzfRPnS=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/PPEJUfekBto/trigger/T-6XU57ba)
   * 2. user has selected any, or a combination of the following filters: any questions, any topic, any sentiment, any rating, any replies 
   *   _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/KvmV-JHFaa4JcoaF-tTS90jnx2TpMa6_5WZvHYKCTrSwiIdvREb76Gaxs55gQNthx8M92I09qgPk6kIbzmaOLqh4MkMSzMroZr8-mw=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/PPEJUfekBto/trigger/78dmzYgEo)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. Action framework ID)
   * @param options Amplitude event options.
   */
  allCommentsReportViewed(
    properties: AllCommentsReportViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AllCommentsReportViewed(properties), options);
  }

  /**
   * Chart Export Menu Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Chart%20Export%20Menu%20Viewed)
   *
   * User goes to download chart by clicking this export icon
   *
   * Triggers:
   * 1. Clicks on the word "export"  
   *   _Triggered on all sources_
   *   ![](https://lh3.googleusercontent.com/yVttoJhWTbOIXg-Gr5V-nxfVWpHqQFwi3D9yBXeseLHE1OiRjckcWKVJG0DO2EKTwLuoLGLyyrIQrctokBlbAFw9aenkHHlFOdJASg=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/jiCeYL12J6/trigger/H9sBUeK66)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. Chart type)
   * @param options Amplitude event options.
   */
  chartExportMenuViewed(
    properties: ChartExportMenuViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChartExportMenuViewed(properties), options);
  }

  /**
   * Chart Exported
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Chart%20Exported)
   *
   * User copies or downloads a chart
   *
   * Triggers:
   * 1. _Triggered on all sources_
   *   ![](https://lh3.googleusercontent.com/lG-dluOr3lEgP3sBNMXmB4PaWp29WMnifc-a9aatUVMGql7CLwsnhRnNID_hC-uHe5kP73xHQbdetC95odshghzbSAfThq_CUBs=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/IJy4VfLWFU/trigger/Lb_3aMSX0)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. Chart type)
   * @param options Amplitude event options.
   */
  chartExported(
    properties: ChartExportedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChartExported(properties), options);
  }

  /**
   * Comments Summary Copied
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Comments%20Summary%20Copied)
   *
   * Users copied the comment summarisation text using the "Copy" button
   *
   * Triggers:
   * 1. click the "Copy" button 
   *   _Triggered on all sources_
   *   ![](https://lh3.googleusercontent.com/xS7rJip2Xv1A0QEnKKrLdS4wQV6vtn05qO6tRVDfFqEG2gSF2wn15IgxFBzfvFRg_aGChhk0YNhGCx_4TVlQy1qKGCHZkm8bm_FH=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/2mFCewwEOc/trigger/9z6vKdSy4)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * @param properties The event's properties (e.g. Question ID)
   * @param options Amplitude event options.
   */
  commentsSummaryCopied(
    properties: CommentsSummaryCopiedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CommentsSummaryCopied(properties), options);
  }

  /**
   * Comments Summary Feedback Given
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Comments%20Summary%20Feedback%20Given)
   *
   * In the Comments Summary drawer users can give feedback about summarisations
   *
   * Triggers:
   * 1. Feedback about the summary is given by clicking the thumb up or thumb down. 
   *   _Triggered on all sources_
   *   ![](https://lh3.googleusercontent.com/_Pjp-o1_vUpS2AEL2ke2wJa774gnN73AL_VbPyzRWBIJVsbIeydCoVwLcG6DQcV7HfWNKpSa_elncYMWS8iXjeHbF9xAeJ51bB0J=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/nkHxi88THL/trigger/4flA152nZ)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * @param properties The event's properties (e.g. Feedback sentiment)
   * @param options Amplitude event options.
   */
  commentsSummaryFeedbackGiven(
    properties: CommentsSummaryFeedbackGivenProperties,
    options?: EventOptions,
  ) {
    return this.track(new CommentsSummaryFeedbackGiven(properties), options);
  }

  /**
   * Comments Summary Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Comments%20Summary%20Viewed)
   *
   * User views the Comment Summarisation drawer
   *
   * Triggers:
   * 1. User clicks the summarisation icon on the Insight Report  
   *   _Triggered on all sources_
   *   ![](https://lh3.googleusercontent.com/az1gXSB2bLvi71aD84uAVY07zWj4EzTfChxCIWS9wF5R4WNx8Pa10a6Evy_6hKSLAh1ynafFRpnOKhd71M-d5gcuzHA4duax2omr=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/1WmMtolQk9/trigger/1QIVQita0)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * @param properties The event's properties (e.g. Context)
   * @param options Amplitude event options.
   */
  commentsSummaryViewed(
    properties: CommentsSummaryViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CommentsSummaryViewed(properties), options);
  }

  /**
   * Custom Heatmap Report Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Custom%20Heatmap%20Report%20Viewed)
   *
   * A users clicks through to the "Custom" tab in the Heatmap Report
   *
   * Triggers:
   * 1. User clicks the Custom tab while viewing the Heatmap Report 
   *   _Triggered on all sources_
   *   ![](https://lh3.googleusercontent.com/Pik_ZSlRzatmjNyHBj4W6UFDxnK65yFQPQfHO25czxE7KdJ_tkEmw7mOQ4jtBfU1GnKpKzY5G8GdFmY-OPN0jG8NTQ4WBqbIq6nq=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/XBIJBW95K/trigger/a4kF-XvQx)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * @param properties The event's properties (e.g. Confidentiality warning displayed)
   * @param options Amplitude event options.
   */
  customHeatmapReportViewed(
    properties: CustomHeatmapReportViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CustomHeatmapReportViewed(properties), options);
  }

  /**
   * Data Safety Policy Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Data%20Safety%20Policy%20Viewed)
   *
   * A user views the Data Safety Policy for the respective Engagement survey.
   *
   * Triggers:
   * 1. Triggered when a user clicks on "More on managing information" from the welcome page/splash page of a survey.
   *
   * The policy is presented to the user as a modal window. 
   *   _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/X6rk_Qc9tKR7hMnedhs5lni6OEAoBxCxkfvqa7OqAw09YSNG0QokdklhQD_1rNAxO2piSadodTtunPpEMtiPajoQTJHNWMBk8BwrDA=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/wzmklTLkmr/trigger/xSWlMiz83)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param options Amplitude event options.
   */
  dataSafetyPolicyViewed(
    options?: EventOptions,
  ) {
    return this.track(new DataSafetyPolicyViewed(), options);
  }

  /**
   * Demographic Group for Heatmap Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Demographic%20Group%20for%20Heatmap%20Added)
   *
   * The Custom Heatmap requires demographic groups to be created and added for the report to generate. User clicks on "Add demographic group" and then configures the group before adding the group by clicking "Add column"
   *
   * Triggers:
   * 1. User enters details about the demographic group and clicks "Add Column" 
   *   _Triggered on all sources_
   *   ![](https://lh3.googleusercontent.com/CFa6CX7N49gp3bZxW2IiLnPd7lPVgYfxzmMspDtMY3HGr0kHcx-X2fwU-4A7rMNcNXpVjw5dqCOaR1nY8do7xMTS11UVG31vENA=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/FBQGu-LnWA/trigger/T9oYYdjs3)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * @param properties The event's properties (e.g. Number of filters applied)
   * @param options Amplitude event options.
   */
  demographicGroupForHeatmapAdded(
    properties: DemographicGroupForHeatmapAddedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DemographicGroupForHeatmapAdded(properties), options);
  }

  /**
   * Emerging Theme Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Emerging%20Theme%20Viewed)
   *
   * A user sees the emerging themes section on the Topic and Themes section of the Comments report. A question needs to have a minimum of 250 comments for themes to be clustered automatically.
   *
   * Triggers:
   * 1. A user sees the emerging themes section. 
   *   _Triggered on all sources_
   *   ![](https://lh3.googleusercontent.com/nruyzuHf1aFER-mbG6TtZLHv5cUafWwe0gnfT7b2r1HyEWtkjR8BgNGzwLr5jN_YTX4fPRc9Y3Brr8dBjhyrVXUiggwD8YkfmaEO3w=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/c1aus1WEkf/trigger/TGMTjer95)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * @param options Amplitude event options.
   */
  emergingThemeViewed(
    options?: EventOptions,
  ) {
    return this.track(new EmergingThemeViewed(), options);
  }

  /**
   * Factor Insight Report Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Factor%20Insight%20Report%20Viewed)
   *
   * A user views an engagement survey factor report. Triggered every time a report is viewed with new data (e.g. changing a filter)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. Action framework ID)
   * @param options Amplitude event options.
   */
  factorInsightReportViewed(
    properties: FactorInsightReportViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FactorInsightReportViewed(properties), options);
  }

  /**
   * Filtered Reports Page Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Filtered%20Reports%20Page%20Viewed)
   *
   * A user views the Filtered Reports Page.
   *
   * Triggers:
   * 1. A user views the page. 
   *   _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/YZE3lTFd4r8vyEWMh9XSM6Lvt7ZyvG79IdV8ISXupAqN2TiA6ieAvW0bdPGJ2m2X4Fhq7C445yycG7vqsVKofn2LQR_uruW8ohk=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/NFa9Nrs2ge/trigger/kn8DoKcNF)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * @param options Amplitude event options.
   */
  filteredReportsPageViewed(
    options?: EventOptions,
  ) {
    return this.track(new FilteredReportsPageViewed(), options);
  }

  /**
   * Focus Area Flagged
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Focus%20Area%20Flagged)
   *
   * The list of questions flagged by the user is updated by the users selecting the flag icon next to a question on the Question Reports page
   *
   * Triggers:
   * 1. Use selects the flag icon next to a question 
   *   _Triggered on all sources_
   *   ![](https://lh3.googleusercontent.com/3USrA-4psyUN_xQd6wxou_apJU8I-4yfErw6cksqCsvjk59sZ2wlevxWuUqhoYrVIBycrjg4muo54JgXHDcCHF4ximw127lXthUR9Q=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/2wV0wWxKxP/trigger/zEpJ6_MYK)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. Is this a recommended focus?)
   * @param options Amplitude event options.
   */
  focusAreaFlagged(
    properties: FocusAreaFlaggedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FocusAreaFlagged(properties), options);
  }

  /**
   * Free Text Questions Report Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Free%20Text%20Questions%20Report%20Viewed)
   *
   * A user views a free text questions report  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. Action framework ID)
   * @param options Amplitude event options.
   */
  freeTextQuestionsReportViewed(
    properties: FreeTextQuestionsReportViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FreeTextQuestionsReportViewed(properties), options);
  }

  /**
   * Group Level Driver Modal Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Group%20Level%20Driver%20Modal%20Viewed)
   *
   * This modal is displayed when users add a filter to Insight reports or Question Reports after the launch of Group Level Driver Analysis
   *
   * Triggers:
   * 1. Click "Add filter" from Questions tab  
   *   _Triggered on all sources_
   *   ![](https://lh3.googleusercontent.com/ixQU6tnsdQS1xNOuj6gLdHdBtxbNA4tJRiolMNkGt4SMAnLcJRFHFV8yxAep7GwNA-39cCxnbcPYt-m85Hx1OhW_Gd50wd_Be8g=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/n0168V_pYe/trigger/3AMN3ErGA)
   * 2. Click "Add filter" from the Insight Reports 
   *   _Triggered on all sources_
   *   ![](https://lh3.googleusercontent.com/MxS_TCctjTK3fy_vbPEpflwJ2hElk_esQMeK2k38R2uk8i2zLBNvriZ7JB6hD4ePdVI2Ta20SixGKc22JvHmfe3FxOMCYoqQcYkS=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/n0168V_pYe/trigger/X5-t_S-ap)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param options Amplitude event options.
   */
  groupLevelDriverModalViewed(
    options?: EventOptions,
  ) {
    return this.track(new GroupLevelDriverModalViewed(), options);
  }

  /**
   * Heatmap Report Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Heatmap%20Report%20Viewed)
   *
   * A users views the 'heatmap' report in Engagement  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. Action framework ID)
   * @param options Amplitude event options.
   */
  heatmapReportViewed(
    properties: HeatmapReportViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new HeatmapReportViewed(properties), options);
  }

  /**
   * Insight Report Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Insight%20Report%20Viewed)
   *
   * A user views an engagement survey report. Triggered every time a report is viewed with new data (e.g. changing a filter)
   *
   * Triggers:
   * 1. When user clicks 'preview report' from any page in Survey Configure. 
   *
   * Is preview? = yes
   *
   *   _Triggered on all sources_
   *   ![](https://lh3.googleusercontent.com/Z48P_H3MN6mDSY7PcUVr505fUrsZ3Nx-tB5yJ7RK-ptXNCy2QqKUPajbh18_-JtRD3PbDijaIkJRPlXQACZMp7gRmnaQ-wAAaquR=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/vPSp8K7Efh2F/trigger/tsxiLfKSu)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. Action framework ID)
   * @param options Amplitude event options.
   */
  insightReportViewed(
    properties: InsightReportViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InsightReportViewed(properties), options);
  }

  /**
   * Multiple Choice Questions Report Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Multiple%20Choice%20Questions%20Report%20Viewed)
   *
   * A user views the multiple choice questions report  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. Action framework ID)
   * @param options Amplitude event options.
   */
  multipleChoiceQuestionsReportViewed(
    properties: MultipleChoiceQuestionsReportViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MultipleChoiceQuestionsReportViewed(properties), options);
  }

  /**
   * Outbound Destination Visited
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Outbound%20Destination%20Visited)
   *
   * This generic event is triggered when users select links within Culture Amp that direct to external locations, including support articles.
   *
   * Triggers:
   * 1. Sent throughout the product when a "Learn more" link (or similar) is clicked, which will redirect to a support article. 
   *   _Triggered on all sources_
   *   ![](https://lh3.googleusercontent.com/fni5SMjPq2s7U9pNs6FherWtMCym4eSKgmMVEqWWs_dB0ybtWejzJzV55V3EKqa_Ab-JS6O5r9mTJ1KfgIbOpiHuwrka70Skm0Y=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/juGA3prPVOqP/trigger/0oxO-qK_x)
   * 2. Sent throughout the product when a link to an external calendar provider, integrated app, or other product is clicked. 
   *   _Triggered on all sources_
   *   ![](https://lh3.googleusercontent.com/IiH5-LOZ9_IyITCJWmoBQVNsE73E4Vy6zN8xMkoM_I2ebuf3CtbWHBr-TPkXzBZhu3M0M-qd7pSYrwZzXkquksYPwENyNUcDZUAt=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/juGA3prPVOqP/trigger/WxwE9ITYl)
   * 3. User clicks on a locked link of a product module they do not have enabled, taking them to the product marketing landing page. 
   *   _Triggered on continuous-reporting-frontend_
   *   ![](https://lh3.googleusercontent.com/TQdnoQXv26jJO8ITfgujjHXIAntwPXQ2GmX-ci2rc_2Gp3oWE2FqfoWatO-3C4Tl-Hr952_BSkNSx1IDzzLCrbAeQzgfrlR-4095=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/juGA3prPVOqP/trigger/wmQOkv8SU)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. Context)
   * @param options Amplitude event options.
   */
  outboundDestinationVisited(
    properties: OutboundDestinationVisitedProperties,
    options?: EventOptions,
  ) {
    return this.track(new OutboundDestinationVisited(properties), options);
  }

  /**
   * Participation Report Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Participation%20Report%20Viewed)
   *
   * A user views a Participation Report.  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. Action framework ID)
   * @param options Amplitude event options.
   */
  participationReportViewed(
    properties: ParticipationReportViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ParticipationReportViewed(properties), options);
  }

  /**
   * Post-Survey Feedback Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Post-Survey%20Feedback%20Submitted)
   *
   * After survey submission, the user rates their experience with the survey process. In Kiosk mode, this then redirects back to the Kiosk Landing Page.
   *
   * Triggers:
   * 1. The user submits the survey by clicking "Submit" 
   *   _Triggered on all sources_
   *   ![](https://lh3.googleusercontent.com/auSnuAip0tfJVoZ0JCAQi_dQah0dZ5tscMHgzOH4YyO7eJDBXrHMSWfa3s745b9uDkT8nweOh8z24OqjWxdzu4KTDMpmhj4Fe1g=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/kysvZJQo9y/trigger/VAKNfPYtF)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * @param properties The event's properties (e.g. Rating)
   * @param options Amplitude event options.
   */
  postSurveyFeedbackSubmitted(
    properties?: PostSurveyFeedbackSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PostSurveyFeedbackSubmitted(properties), options);
  }

  /**
   * Questions Report Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Questions%20Report%20Viewed)
   *
   * A user views the Ratings questions within the Questions Report.  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. Action framework ID)
   * @param options Amplitude event options.
   */
  questionsReportViewed(
    properties: QuestionsReportViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new QuestionsReportViewed(properties), options);
  }

  /**
   * Redaction Request Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Redaction%20Request%20Submitted)
   *
   * A user submits a redaction request for comment/s in an Engagement survey report, which automatically sends a message to support on behalf of the customer.
   * The request is triaged later between support and customer directly, in adherence to our comment policy.
   *
   * Triggers:
   * 1. 
   * Event triggered once user has selected Submit request option, from the Request redaction modal. 
   *   _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/6WeSz1xD1R39qCabhd3fzyJ60S1x8NrTXDhqlZdyR7FTno_jRSfzlwEE1H3JvpaGfBBxr6CaBPSRpp6CdoHXKvS8En3EoxeaVGY=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/gf6a0syIr/trigger/qhj-q-Bsn)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param options Amplitude event options.
   */
  redactionRequestSubmitted(
    options?: EventOptions,
  ) {
    return this.track(new RedactionRequestSubmitted(), options);
  }

  /**
   * Report Exported
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Report%20Exported)
   *
   * Generic event for a user exporting a report anywhere in the platform.
   *
   * Triggers:
   * 1. Triggered when admin clicks the Export usage button in the Develop module. 
   *   _Triggered on all sources_
   *   ![](https://lh3.googleusercontent.com/ilBfjw8lxsjNcrHciUCEkxly8mgXvX3PtP2zmzy0EuEyQ4zbI5Ppcjycov6Nt93MO4brLOBmDKNLUokaaM303cvsNLovd4Cbooc82A=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/fFWUEcBxKsd3/trigger/IgtoQxKPN)
   * 2. In the report screen, admin selects any of Print, Acrobat (.pdf), Excel (.xls), Comma separated (.csv). This downloads or prints the whole report in the specified format. 
   *   _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/30luw_Bm6ed_dm9H5xIw5WVSDxcQCIfbql_kKUWH2LdvJMPdzvvrBdpjMUiU73RTrBfGVN-QwOKHrwpwAljPWWgyexIB8FdQ6kiNbg=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/fFWUEcBxKsd3/trigger/-dYBSs0tr)
   * 3. After selecting a value for each field in the Build PowerPoint screen, admin selects "Build PowerPoint". This downloads the .ppt file. 
   *   _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/zV2T9FtRNEV2wVyA3w_gG_0JveIhUTA5A4aWKATW4XYcEjemLsxIDaEgoDItBu15e1pkTCB4DCxkZH8BJTETK-JQytz1w-2oagTq=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/fFWUEcBxKsd3/trigger/i9MgVqXlz)
   * 4. Admin downloads a report of all users invited to view a survey's reports. 
   *   _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/u8QM3-xdP5EAUN7Dtei9QFQ_8tCUpDAsFA-46Tu0g_nwiZNwlOjRdCzYJXlWcC4l-S2YBLOtVFl4gVj5IGxyyMTVolgYiwjlmYhIIw=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/fFWUEcBxKsd3/trigger/nSYlVSXpT)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. Context)
   * @param options Amplitude event options.
   */
  reportExported(
    properties?: ReportExportedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReportExported(properties), options);
  }

  /**
   * Report Viewer Bulk Deletion Started
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Report%20Viewer%20Bulk%20Deletion%20Started)
   *
   * The job to bulk delete report viewers (in survey sharing configuration) is started.  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * @param options Amplitude event options.
   */
  reportViewerBulkDeletionStarted(
    options?: EventOptions,
  ) {
    return this.track(new ReportViewerBulkDeletionStarted(), options);
  }

  /**
   * Report Viewer Export Download Started
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Report%20Viewer%20Export%20Download%20Started)
   *
   * An admin starts to download a list of report viewers, so they can update the list and reupload it, or load it onto a different report. This download can take up to 60 seconds and the user is warned that they must stay on the page for it to complete.
   *
   * Triggers:
   * 1. Within Survey Config, the admin clicks on "Export report-viewers" and the report starts to download. 
   *   _Triggered on all sources_
   *   ![](https://lh3.googleusercontent.com/zvuBUnGS2en4X_5x6vKvmzujbsD4sGU61vCheURKbmiYMHQbb3Yr2skcJS1Cgl9zkkKqwC936bc3Bw46itpNOMnfpk8xG-P1m8Y=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/fUNTVA0IWo/trigger/QOZwkeIw6)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param options Amplitude event options.
   */
  reportViewerExportDownloadStarted(
    options?: EventOptions,
  ) {
    return this.track(new ReportViewerExportDownloadStarted(), options);
  }

  /**
   * Report Viewer Import Error File Downloaded
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Report%20Viewer%20Import%20Error%20File%20Downloaded)
   *
   * An admin downloads a list of errors found during the report viewer import process. They can fix these errors and reupload a new file.
   *
   * Triggers:
   * 1. Admin clicks on "Download a spreadsheet with errors" after file validation. 
   *   _Triggered on all sources_
   *   ![](https://lh3.googleusercontent.com/Iw4x_NViILp3conCH1-T6Vh_jaXoB0VOmF9t4R5hJXmd3a9ilZPlfrQWRfgEz7MsPxd32nwOg1Uis12fFof9Otkk4GJhqOcMv4I=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/lMFYT8r-P0/trigger/H8QVfGlGL)
   * 2. Admin clicks on "Download a spreadsheet with the errors" after the import has completed. 
   *   _Triggered on all sources_
   *   ![](https://lh3.googleusercontent.com/Vb3rqVwqOMi60SVLW3sErIjWwgvtGbNFkutqYzWHLqUze-R2oWTNOUIqV1IO73IZGMRunKJZzRUu876KjihYu5wMYwqtewsEWV-F=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/lMFYT8r-P0/trigger/jv9NBYLMp)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. Job ID)
   * @param options Amplitude event options.
   */
  reportViewerImportErrorFileDownloaded(
    properties: ReportViewerImportErrorFileDownloadedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReportViewerImportErrorFileDownloaded(properties), options);
  }

  /**
   * Report Viewers Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Report%20Viewers%20Updated)
   *
   * An admin or Survey HRBP adds or removes viewers from a filtered report.
   *
   * Triggers:
   * 1. Triggered when clicking "Save" 
   *   _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/sL5p_C4GmpU9moeWGxOZr6CP4rZAuLle73E6KC6CWwRjxH1ecsvzCOj0kb_n_vFhO1bpziN6_ipKneSUbUzrxEANq2u2W2SsNXTv=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/BuOsETEmzM/trigger/SUNStGEb7)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * @param properties The event's properties (e.g. Is Engage HR business partner)
   * @param options Amplitude event options.
   */
  reportViewersUpdated(
    properties: ReportViewersUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReportViewersUpdated(properties), options);
  }

  /**
   * Single Question Report Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Single%20Question%20Report%20Viewed)
   *
   * The report for a single question is viewed in Engagement  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. Action framework ID)
   * @param options Amplitude event options.
   */
  singleQuestionReportViewed(
    properties: SingleQuestionReportViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SingleQuestionReportViewed(properties), options);
  }

  /**
   * Specific Survey Rules Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Specific%20Survey%20Rules%20Viewed)
   *
   * A user views the specific rules for the survey, which is written by their organisation.
   *
   * Triggers:
   * 1. User reaches this page by selecting "Settings for this survey" on the survey welcome screen 
   *   _Triggered on Legacy events (non-Avo functions)_
   *   ![](https://lh3.googleusercontent.com/d-VMcCwGi70PMgSPe5SRxkGcftOMilpuLt-TbgsQF8lvm8WEq2j6RAjrf6GKJVlkPww1cD7dIOeNNEscy8P7ytaonzy537ROyxU=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/7IkFzL1Gst/trigger/_vaLt7LIW)
   * 2. Triggered when a user clicks on "Settings for this survey", to view the survey rules in English.
   *
   * "Settings for this survey" is an option on the survey's welcome page.
   * Once selected, the dialogue is presented to the user as a modal window. 
   *   _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/Drb-3AWb5fQxo38ovLdRDZT59pRobxxwhPY12eDRN2GQ2BmGyyxv61rgAYnnsg87CsHWGt7J85MtQsTwqRTLH5mNxOOaR8aEXTTV3A=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/7IkFzL1Gst/trigger/uAoqbQjp-)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param options Amplitude event options.
   */
  specificSurveyRulesViewed(
    options?: EventOptions,
  ) {
    return this.track(new SpecificSurveyRulesViewed(), options);
  }

  /**
   * Sub Report Viewers Deleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Sub%20Report%20Viewers%20Deleted)
   *
   * The "Remove All" option of a filtered report is used to delete report viewers
   *
   * Triggers:
   * 1. _Triggered on all sources_
   *   ![](https://lh3.googleusercontent.com/KJONf5UcF696pwYsvZ73KBjgJeuE-9KF_RsGREQ1TUuGWJwI08MfOG-uSs07hRZpyWsp-XKJHsX8OtKd2BD9MnPsj4z0L4lW81XG=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/eOrU2R2oSf/trigger/kShw00vCt)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * @param properties The event's properties (e.g. Job failed)
   * @param options Amplitude event options.
   */
  subReportViewersDeleted(
    properties: SubReportViewersDeletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SubReportViewersDeleted(properties), options);
  }

  /**
   * Summary Insight Report Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Summary%20Insight%20Report%20Viewed)
   *
   * A user views the summary insight report  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. Action framework ID)
   * @param options Amplitude event options.
   */
  summaryInsightReportViewed(
    properties: SummaryInsightReportViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SummaryInsightReportViewed(properties), options);
  }

  /**
   * Survey Configuration - Post Launch Trend Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Survey%20Configuration%20-%20Post%20Launch%20Trend%20Saved)
   *
   * A user saves their selection of surveys to include in question and factor trends by clicking on the 'Save' button
   *
   * Triggers:
   * 1. _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/8_cOgvR000veim3nTVQ6o7ZQyBdQCQlvey_2jHGazRwDqscmDVhpVpXdOCYKCdZW_O527Wblj7GnSfhtihcs9VIE35cGTYOeyQKh3A=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/oxnyIUDlHV/trigger/7NuQt7Tp4)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. Date of oldest survey included)
   * @param options Amplitude event options.
   */
  surveyConfigurationPostLaunchTrendSaved(
    properties: SurveyConfigurationPostLaunchTrendSavedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SurveyConfigurationPostLaunchTrendSaved(properties), options);
  }

  /**
   * Survey Configure - Kiosk Mode Link Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Survey%20Configure%20-%20Kiosk%20Mode%20Link%20Clicked)
   *
   * A user clicks on a link in the kiosk mode section of the survey configuration.
   *
   * Triggers:
   * 1. The user clicks the participants link.  
   *   _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/mJxY_Fct98ae5Onf2QpTWX8DGQJbdgRHj5fr7tFG8IRvwWJgvppaEZLFRpM9nAc4finEEj1qWMwt7JSrtv7OvqnmeCxWNEMaIWc=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/U-2WrQlwdl/trigger/M5MyPmt9u)
   * 2. A user clicks the kiosk survey link. 
   *   _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/mQiIt7TqK-HO_4IpWoCEDgVT4_HT-JJ3ahYxQltg8EJY2BP7aELSLNC6_U3sbhlt0NWMo4SmOBQwiQ0GOvm_TDk0V4djT-ssjxkQ=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/U-2WrQlwdl/trigger/AW9CbbFN0)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * @param properties The event's properties (e.g. Element clicked name)
   * @param options Amplitude event options.
   */
  surveyConfigureKioskModeLinkClicked(
    properties: SurveyConfigureKioskModeLinkClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SurveyConfigureKioskModeLinkClicked(properties), options);
  }

  /**
   * Survey Configure - Kiosk Mode Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Survey%20Configure%20-%20Kiosk%20Mode%20Updated)
   *
   * Triggered when Kiosk Mode is enabled, disabled or has the details updated in the survey configuration section (including post-launch).
   *
   * Triggers:
   * 1. _Triggered on murmur back end_
   *   ![](https://lh3.googleusercontent.com/fcem-edJB2chxMFS2j5u-EQi5nUhBv8Ntv1ptpo_5zSM-ZAmwjAhRatdBTyCOQiovVdp3I831jtkuMW9IyvLDr_GOiNiBSwSI-yg=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/n8WTDeTMTx/trigger/OllTs6h1L)
   * 2. A user clicks 'Save changes' to update the kiosk mode code format and/or message. 
   *   _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/f6vboltqk8uI56co8AX2UlW3lSPetKDVQcnpGUetw26FTjTxgQJhOx-c6ndMWGoKYxYs3_faogrObru4wBcAfvzn4oWJ1D9vmoCK=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/n8WTDeTMTx/trigger/8XdZjuBaK)
   * 3. A user clicks 'Deactivate' to disable the kiosk mode on a survey. 
   *   _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/jhHqskIHTuAq3AhAZlWB8UUcnBMfIwZ0eoxziOt6lsGToeYipUyRInxXXjqSVQDMoxjHwgR_iWVrd5yY1XVPY7Dsw_5AZiF5DKw=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/n8WTDeTMTx/trigger/5CPOLdO3F)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * @param properties The event's properties (e.g. Locale)
   * @param options Amplitude event options.
   */
  surveyConfigureKioskModeUpdated(
    properties: SurveyConfigureKioskModeUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SurveyConfigureKioskModeUpdated(properties), options);
  }

  /**
   * Survey Configure - Likert Scale Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Survey%20Configure%20-%20Likert%20Scale%20Updated)
   *
   * An admin updates the colour of the likert scale on their survey in the survey settings page.
   *
   * *Trigger: A user clicks the 'save changes' button under the survey colours section.*
   *
   *
   *
   *
   * @param properties The event's properties (e.g. Likert colour)
   * @param options Amplitude event options.
   */
  surveyConfigureLikertScaleUpdated(
    properties: SurveyConfigureLikertScaleUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SurveyConfigureLikertScaleUpdated(properties), options);
  }

  /**
   * Survey Configure - Module Filter Updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Survey%20Configure%20-%20Module%20Filter%20Updated)
   *
   * A module filter (e.g Performance rating) is updated by selecting or deselecting the filter dimension from the list on the Survey Configure - Demographic page. Performance and rating are currently the only module and dimension options (in future there will be more).
   *
   * Triggers:
   * 1. _Triggered on all sources_
   *   ![](https://lh3.googleusercontent.com/xOiS_PaxD5ReWosgTjJWz_5Sr_kglzaKoZK_TMa8zI5nyOxrOrXSxclzCwxAM87Y_rdy9HzDO4YupKJf52Qkt7UBZww2_UV9lyKqCQ=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/j3JWKaF5bQ/trigger/VriGRXUBY)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: api
   *
   * @param properties The event's properties (e.g. Filter dimension)
   * @param options Amplitude event options.
   */
  surveyConfigureModuleFilterUpdated(
    properties: SurveyConfigureModuleFilterUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SurveyConfigureModuleFilterUpdated(properties), options);
  }

  /**
   * Survey Configure - Post Launch Trend Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Survey%20Configure%20-%20Post%20Launch%20Trend%20Viewed)
   *
   * A user views the Survey Configure - Post Launch Trend page
   *
   * Triggers:
   * 1. _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/hnKF5QFW-ZkGVeXsT0DPce_jBN8QPS0lz_QeL-QQO1e5tf9oMPuSt74QMJo1v-TKp_t2GTWdW6dNfMrWEfV1zQAXIskqDmDKfEyY=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/UK-jbbFdsiNQ/trigger/em883lJJ6)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. Custom content enabled)
   * @param options Amplitude event options.
   */
  surveyConfigurePostLaunchTrendViewed(
    properties?: SurveyConfigurePostLaunchTrendViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SurveyConfigurePostLaunchTrendViewed(properties), options);
  }

  /**
   * Survey Configure - Preview Link Copied
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Survey%20Configure%20-%20Preview%20Link%20Copied)
   *
   * User clicks on 'Copy Link'  in Survey Configure. This copies a link of the survey preview to their clipboard.
   *
   * Triggers:
   * 1. User clicks on 'Copy Link' from Survey Configure - Questions. Context = 'Survey Configure - Questions' 
   *   _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/d8Zpeevu0hlZhbshoACEqNKs4qk19L1HYqn0RzMVH-zmYSk8EiHrEjU-gb7kwTUsH5ldEh8ofDTNy_4Uj7mpioXBgOJfLDbc2X8=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/Mbzr6ZF4VN/trigger/oHkttCdtE)
   * 2. User clicks on 'Copy Link' from the Survey Designer. Context = 'Survey Designer' 
   *   _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/nO1nN9ftO6j3n_tx6VY4ouQIQMJhVs7AHOdnfvHAcycAHtdSRETBkMPPiFy-GCnLOy8AMSonZPNb90wUt5QrSV5CymsI-UTnZdBf=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/Mbzr6ZF4VN/trigger/_38Ar3wwB)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. Context)
   * @param options Amplitude event options.
   */
  surveyConfigurePreviewLinkCopied(
    properties?: SurveyConfigurePreviewLinkCopiedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SurveyConfigurePreviewLinkCopied(properties), options);
  }

  /**
   * Survey Configure - Questions Exported
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Survey%20Configure%20-%20Questions%20Exported)
   *
   * Admin exports the list of survey questions into either Acrobat (pdf), Excel (xls), or CSV format (csv).
   *
   * Triggers:
   * 1. From the Survey Designer, user clicks 'Export' dropdown, and then chooses to export questions to either an Acrobat (pdf), Excel (xls), or CSV file. Context = 'Survey Designer' 
   *   _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/UtcJgYtg7Ims3N86FHcBRVX8S79SfW9VoCzUjqI-r3fkGbFV5Va374y5PMLcOYWHhL0WPSbGa0zOOO1MqTVW1gB599JVPbNXKXc=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/CXMiY_wy1_/trigger/emCUK9ODh)
   * 2. From Survey Configure - Questions, user clicks 'Export' dropdown, and then chooses to export questions to either an Acrobat (pdf), Excel (xls), or CSV file. Context = 'Survey Configure - Questions' 
   *   _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/WzGw0aAQezSP42uV6rgF5MSqC3-wLxj4e2F1ZLc19uneSTcIuxsoAuSHxK5o2gNPLpOSWS8iEDi3EUeSo_ilCRNZxvtsqEe1ruJH=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/CXMiY_wy1_/trigger/WVJhJW6qz)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. Context)
   * @param options Amplitude event options.
   */
  surveyConfigureQuestionsExported(
    properties?: SurveyConfigureQuestionsExportedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SurveyConfigureQuestionsExported(properties), options);
  }

  /**
   * Survey Configure - Questions Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Survey%20Configure%20-%20Questions%20Viewed)
   *
   * User views the Questions page within Survey Configure. It includes a link to the question designer.
   *
   * Triggers:
   * 1. User selects Questions from the Survey Configure sidebar, and lands on the Questions page.  
   *   _Triggered on all sources_
   *   ![](https://lh3.googleusercontent.com/XtOVdVPW2ugO1QexX3AEx7pRQifVE8YOhMUcw6qt7iP0h6g9C3NVrtFv1XgyMXqUpYfSXz6vb5MJ1T9bhu6MRQI6hWLwl1FbAkjc=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/9Nm96jymZJaq/trigger/KguXBCJe0)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. Custom content enabled)
   * @param options Amplitude event options.
   */
  surveyConfigureQuestionsViewed(
    properties?: SurveyConfigureQuestionsViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SurveyConfigureQuestionsViewed(properties), options);
  }

  /**
   * Survey Design Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Survey%20Design%20Viewed)
   *
   * User views the Survey Design page, where they can start adding and editing questions and sections.
   *
   * Triggers:
   * 1. Admin lands on the Survey Design page. This can be reached from selecting "Edit questions" on the Survey Configure - Questions page. 
   *   _Triggered on all sources_
   *   ![](https://lh3.googleusercontent.com/dpeHnYksrk-HOeva_asOdJMQ2JrXU0Ex9Xc1fHgnlcQSOUGCGn7wE5RyOUHp9BcrbvW_jnYohUAcGTj-TtnTaHRODbms4IgUCmZL=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/6h5Qg4oQyu/trigger/RGCSaTSS9)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param options Amplitude event options.
   */
  surveyDesignViewed(
    options?: EventOptions,
  ) {
    return this.track(new SurveyDesignViewed(), options);
  }

  /**
   * Survey Started
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Survey%20Started)
   *
   * The user clicks on 'Get started' on the survey splash page, and is able to start answering questions in the survey.
   *
   * Triggers:
   * 1. Triggered when a user clicks on "Take survey button" from the welcome page of a survey. 
   *   _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/JbY19La7plBzv-oDFNdPTP8xJKpAbHdezMWrb_azJQ0EKXEFcQS0EliDcVeBLltCGbKsCj6z4iMHoflJnO-NFIo4l0iNvybgYSE=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/MI_73_JsAq_s/trigger/yCGOy2ujE)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param options Amplitude event options.
   */
  surveyStarted(
    options?: EventOptions,
  ) {
    return this.track(new SurveyStarted(), options);
  }

  /**
   * Survey Summary Creation Banner Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Survey%20Summary%20Creation%20Banner%20Viewed)
   *
   * An admin lands on a page where there is a banner advertising the new Survey Summary report, prompting them to configure the report for the survey. NOTE: this event over-reported. It is still sent when the user returns to the insight report, even after they have dismissed the banner for that report (the banner doesn't display, but the event is still posted).
   *
   * Triggers:
   * 1. Admin lands on the Insight Report some days after the survey has closed.  
   *   _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/jYlF45sShL7TavA4qsBWU0oPIsIAzJI-r5Rku0XzPFyXeyoLVAQcCwScLNwzj2A2TgTi9Liyg8rPjWlUZEJj2plZUKbNEw7o2YQGgA=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/N1Ps9FK2e2/trigger/_nwUgWpFw)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. Context)
   * @param options Amplitude event options.
   */
  surveySummaryCreationBannerViewed(
    properties?: SurveySummaryCreationBannerViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SurveySummaryCreationBannerViewed(properties), options);
  }

  /**
   * Survey Welcome Page Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/culture-amp/%F0%9F%8C%88%20Product%20-%20Production/events/main/latest/Survey%20Welcome%20Page%20Viewed)
   *
   * A user visits the platform to take a survey and views the survey welcome page.
   *
   * Triggers:
   * 1. User lands on the newly designed welcome page of a survey, usually by clicking a link in a notification. 
   *   _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/OesneK-zzDRwJ8BYzISvEoa9tnhz3eyk8sl6CP5tA84fITLJm7MbGIA3dEGPlOs4TvDlDItEGoyafnZ0JHPkjSFg8Dn4p-gMOCg=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/JJvFiP6nu_6h/trigger/2OFBXoC91)
   * 2. User lands on the old version of the welcome page of a survey. 
   *   _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/o4tvxP6-1dRjjbPvjCW1Byh9ovR08sGrHNWunoE6cmxxuQ1fn91tYpLxaWjWoDWAWH96--YxktnC5wihMyNoKFLnaXuw7WKCkLuLVw=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/JJvFiP6nu_6h/trigger/QgGd_wyyM)
   * 3. When user clicks 'preview survey' in any any page in Survey Configuration.
   *
   * Is preview? = yes 
   *   _Triggered on murmur_
   *   ![](https://lh3.googleusercontent.com/dZYeeZOxd7KY-kPT_hKFIPS_i6Rwr5xP38cQ9RBKpBwbtHUvSNHbYpyfzVVrN_4A0xKWHwkoVlcUvMs7m-QTlnrw0A7u_fToP78_=w700)  
   *   [View trigger in Avo](https://www.avo.app/schemas/SyotC3NRBiaKYbijsQS9/events/JJvFiP6nu_6h/trigger/T-2gYUz5Y)  
   *
   * _This description was published from [Avo](https://avo.app/schemas/SyotC3NRBiaKYbijsQS9)_
   *
   * Owner: data@amplitude.com
   *
   * @param options Amplitude event options.
   */
  surveyWelcomePageViewed(
    options?: EventOptions,
  ) {
    return this.track(new SurveyWelcomePageViewed(), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
